import { render, staticRenderFns } from "./playlists-table-block.vue?vue&type=template&id=c8e1a4da&"
import script from "./playlists-table-block.vue?vue&type=script&lang=js&"
export * from "./playlists-table-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports